import React from 'react';

// Right-hand column of the kiosk page: the selected figure preview card and
// the static instructions card (legacy kiosk_config ERB page layout).
export default function KioskFigureCard({ figure, error }) {
  return (
    <>
      <div className="card mb-4">
        <div className="card-header bg-success text-white">
          <h5 className="mb-0">
            <i className="bi bi-eye" /> Figure Preview
          </h5>
        </div>
        <div className="card-body">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {figure && (
            <div className="figure-info mt-3">
              {figure.imageUrl && <img className="img img-fluid" src={figure.imageUrl} />}
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Type:</strong>
                    <span
                      className={`figure-type-badge figure-type-${figure.type.toLowerCase()}`}
                    >
                      {figure.type}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Identifier:</strong>
                    <span className="ms-2">{figure.identifier}</span>
                  </p>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <p>
                    <strong>Probability:</strong>
                    <span className="ms-2">{figure.probability}</span>
                  </p>
                </div>
                <div className="col-md-3">
                  <p>
                    <strong>Box:</strong>
                    <span className="ms-2">
                      {figure.x1}, {figure.y1} - {figure.x2}, {figure.y2}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">
            <i className="bi bi-info" /> Instructions
          </h5>
        </div>
        <div className="card-body">
          <ol>
            <li>
              <strong>Select a Publication</strong> from the dropdown
            </li>
            <li>
              <strong>Select a Page</strong> from the second dropdown
            </li>
            <li>
              <strong>Select a Figure</strong> from the third dropdown
            </li>
            <li>Review the figure preview and details</li>
            <li>
              <strong>Save the Configuration</strong> using the button
            </li>
          </ol>
          <div className="alert alert-warning">
            <i className="bi bi-exclamation-triangle" />
            <strong>Note:</strong> Only public publications and figures with high confidence
            (probability more than 0.6) can be selected.
          </div>
        </div>
      </div>
    </>
  );
}
